// moment-timezone WITHOUT its bundled world time-zone database (760 KB of JSON parsed on every
// first load), plus the only zone the app uses: Asia/Kolkata (and its old alias Asia/Calcutta).
// Packed data copied verbatim from moment-timezone/data/packed/latest.json (tz 2023d). If a new
// zone is ever needed, add its packed line here instead of importing 'moment-timezone'.
import moment from 'moment-timezone/moment-timezone';

if (!moment.tz.zone('Asia/Kolkata')) {
	moment.tz.add(
		'Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6'
	);
	moment.tz.link('Asia/Kolkata|Asia/Calcutta');
}

export default moment;
